document.addEventListener('DOMContentLoaded', function() {
    const banner = document.getElementById('newsletterBanner');
    const closeBtn = document.getElementById('closeBanner');

    if (localStorage.getItem('newsletter_banner_closed') !== 'true') {
        banner.classList.add('show');
    }

    closeBtn.addEventListener('click', function() {
        localStorage.setItem('newsletter_banner_closed', 'true');
        banner.classList.remove('show');
    });
});
